import React, { Fragment } from 'react';

import { NarrowFormFlex, FormBox, FormGroupLoader, FormLegendLoader, RadioGroupLoader } from 'components/shared/form';

function Loader() {
  return (
    <Fragment>
      <NarrowFormFlex>
        <FormBox width={1}>
          <FormLegendLoader mb="1rem" width="5rem" />
        </FormBox>
      </NarrowFormFlex>

      <NarrowFormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="3.5rem" />
        </FormBox>
      </NarrowFormFlex>

      <NarrowFormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="6.25rem" />
        </FormBox>
      </NarrowFormFlex>

      <NarrowFormFlex>
        <FormBox width={[1, 1, 1 / 2]}>
          <FormGroupLoader labelWidth="6rem" />
        </FormBox>
        <FormBox width={[1, 1, 1 / 2]}>
          <FormGroupLoader labelWidth="10rem" />
        </FormBox>
      </NarrowFormFlex>

      <NarrowFormFlex>
        <FormBox width={1}>
          <RadioGroupLoader inline labelWidth="21.875rem" />
        </FormBox>
      </NarrowFormFlex>

      <NarrowFormFlex>
        <FormBox width={1}>
          <RadioGroupLoader inline labelWidth="10rem" />
        </FormBox>
      </NarrowFormFlex>
    </Fragment>
  );
}

export default Loader;
